import React from 'react';
import { Check, Info, AlertTriangle, X } from 'lucide-react';

const variantConfig = {
  success: {
    icon: Check,
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
  },
  info: {
    icon: Info,
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
  },
  warning: {
    icon: AlertTriangle,
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
  },
  error: {
    icon: X,
    iconBg: 'bg-red-100',
    iconColor: 'text-red-600',
  },
};

export default function Toast({
  variant = 'info',
  title,
  description,
  actions,
  onDismiss,
}) {
  const config = variantConfig[variant] || variantConfig.info;
  const Icon = config.icon;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 right-6 z-[60] bg-white rounded-xl shadow-lg border border-gray-200 p-4 max-w-sm transition-all duration-300"
    >
      <div className="flex items-start gap-3">
        <div className={`p-1.5 rounded-full flex-shrink-0 ${config.iconBg}`}>
          <Icon className={`w-4 h-4 ${config.iconColor}`} />
        </div>
        <div className="flex-1 min-w-0">
          {title && <div className="font-medium text-sm text-gray-900">{title}</div>}
          {description && (
            <div className="text-xs text-gray-500 mt-0.5">{description}</div>
          )}
          {actions && actions.length > 0 && (
            <div className="flex gap-3 mt-2">
              {actions.map((action, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={action.onClick}
                  className="text-xs font-medium text-purple-600 hover:text-purple-700"
                >
                  {action.label}
                </button>
              ))}
            </div>
          )}
        </div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
